import { render, staticRenderFns } from "./advertisers-app.vue?vue&type=template&id=8bacea4e"
import script from "./advertisers-app.vue?vue&type=script&lang=js"
export * from "./advertisers-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports